import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {TimeServiceBase} from '@app/shared/time.service.base';

@Injectable()
export class TimeService extends TimeServiceBase {
    constructor(http: HttpClient) {
        super(http);
    }

    now(): moment.Moment {
        if (localStorage) {
            const timeZone = localStorage.getItem('timeZone');
            if (timeZone) {
                return moment().tz(timeZone);
            }
        }

        return moment();
    }
}
